var path = 'src/app/patients/pkd/nutrition.html';
var html = "<h1 class=page-header>Nutrition</h1> <div nutrition-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/pkd/nutrition.html
 ** module id = 513
 ** module chunks = 0
 **/